import * as actions from './actions';
import * as userActions from '../user/actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    isData: false,
    themes: null,
    dateFrom: null,
    dateTo: null,
};

export const digestsSuggestionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.SET_DIGESTS_SUGGESTION_DATA:
            return {
                isData: true,
                themes: action.data.themes,
                dateFrom: action.data.dateFrom,
                dateTo: action.data.dateTo,
            };

        case actions.CLEAN_DIGESTS_SUGGESTION_DATA:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            // console.log('+++LOGIN USER 8+++');
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            console.log('+++CLEAN PERSISTED STORAGE 10+++');
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/digestsSuggestions/reducer.js